import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ShowcaseGet } from '../../services';

export const fetchShowcaseGet = createAsyncThunk(
    'showcaseGet/fetchShowcaseGet',
    async ({ id }) => {
        const response = await ShowcaseGet(id)
        return response.result
    }
);

const showcaseGetSlice = createSlice({
    name: 'showcaseGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseGetSlice.reducer;
